module.exports = __webpack_public_path__ + "img/book_460.d629d807.png";